"use strict";

exports.__esModule = true;
exports.VirtualScroller = void 0;
var _identity2 = _interopRequireDefault(require("ramda/src/identity"));
var _times2 = _interopRequireDefault(require("ramda/src/times"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactWindow = require("react-window");
var _core = require("@blueprintjs/core");
var _ListItems = require("./ListItems");
var _helper = require("../DropdownCheckboxList/helper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var List = (0, _styledComponents["default"])(_reactWindow.VariableSizeList).withConfig({
  displayName: "VirtualScroller__List",
  componentId: "sc-i8lfih-0"
})(["padding:0;"]);
var VirtualScroller = exports.VirtualScroller = function VirtualScroller(props) {
  var items = props.items,
    _props$searchText = props.searchText,
    searchText = _props$searchText === void 0 ? "" : _props$searchText,
    _props$virtualScrollP = props.virtualScrollProps,
    virtualScrollProps = _props$virtualScrollP === void 0 ? {
      itemSize: 31,
      itemCount: 10,
      overscanCount: 5
    } : _props$virtualScrollP,
    _width = props.width,
    renderItemLabel = props.renderItemLabel,
    renderItemText = props.renderItemText;
  var listRef = (0, _react.useRef)(null);

  /* To reset the height of each item after filtering (needed for lists with categories) */
  (0, _react.useEffect)(function () {
    if (listRef.current) {
      listRef.current.resetAfterIndex(0);
    }
  }, [searchText]);
  var filteredData = function filteredData(searchText) {
    if (searchText === void 0) {
      searchText = "";
    }
    var itemPredicate = props.itemPredicate;
    if (itemPredicate && searchText) {
      return items.filter(function (item) {
        return itemPredicate(searchText, item);
      });
    }
    return items;
  };
  var fData = filteredData(searchText);

  /* The height of the element would be different if we show the categories inside the dropdown */
  var getItemSize = function getItemSize(index) {
    var getItemCategory = props.getItemCategory;
    if (typeof getItemCategory === "function") {
      var shouldShowDivider = false;
      var category = getItemCategory(fData[index]);
      var getCategoryTitle = props.getCategoryTitle;
      var title = typeof getCategoryTitle === "function" ? getCategoryTitle(category) : category;
      var hasTitle = title != null && title !== "";
      if (index === 0) {
        shouldShowDivider = hasTitle;
      } else {
        var previousItem = fData[index - 1];
        shouldShowDivider = getItemCategory(previousItem) !== category;
      }
      return shouldShowDivider && hasTitle ? 57 : 31;
    }
    return itemSize;
  };
  var itemSize = virtualScrollProps.itemSize,
    itemCount = virtualScrollProps.itemCount,
    overscanCount = virtualScrollProps.overscanCount;
  var getListHeight = function getListHeight(data) {
    var visibleItemsCount = data.length < itemCount ? data.length : itemCount;
    var listHeight = 0;
    (0, _times2["default"])(_identity2["default"], visibleItemsCount).forEach(function (val) {
      listHeight += getItemSize(val);
    });
    return listHeight;
  };
  var width = (0, _helper.useWidth)(renderItemText, renderItemLabel, fData);
  return /*#__PURE__*/_react["default"].createElement(List, {
    ref: listRef,
    className: _core.Classes.MENU,
    height: getListHeight(fData),
    width: _width || width,
    itemCount: fData.length,
    itemSize: getItemSize,
    overscanCount: overscanCount
  }, (0, _ListItems.ListItems)(Object.assign({}, props, {
    items: fData
  })));
};